import React from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { LightThemeColors } from '../../Themes';
import SearchInput from '../SearchInput';
import SelectInput from '../SelectInput';

function VFDropdownInput({
  theme,
  getLayout,
  toggle,
  open,
  close,
  isDisabled,
  label,
  placeholderStyle,
  titleStyle,
  opacity,
  labelStyle,
  labelFontSize,
  isArrowShown,
  arrowIcon,
  selectedItem,
  selectedLabelStyle,
  labelProps,
  isVisible,
  arrowStyle,
  style,
  isSearchable,
  searchInput,
  handleSearchInputFocus,
  handleSearchInput,
  forwardedRef,
  searchLabel,
  searchInputFontSize,
  ...props
}) {
  const renderSearchInput = () => (
    <SearchInput
      getLayout={getLayout}
      toggle={toggle}
      open={open}
      close={close}
      label={label}
      labelStyle={labelStyle}
      isArrowShown={isArrowShown}
      labelProps={labelProps}
      arrowStyle={arrowStyle}
      arrowIcon={arrowIcon}
      style={style}
      handleSearchInputFocus={handleSearchInputFocus}
      handleSearchInput={handleSearchInput}
      isSearchable={isSearchable}
      searchInput={searchInput}
      forwardedRef={forwardedRef}
      labelFontSize={labelFontSize}
      searchInputFontSize={searchInputFontSize}
      {...props}
    />
  );
  const renderSelectText = () => (
    <SelectInput
      theme={theme}
      getLayout={getLayout}
      toggle={toggle}
      isDisabled={isDisabled}
      label={label}
      placeholderStyle={placeholderStyle}
      titleStyle={titleStyle}
      opacity={opacity}
      labelStyle={labelStyle}
      isArrowShown={isArrowShown}
      arrowIcon={arrowIcon}
      selectedItem={selectedItem}
      selectedLabelStyle={selectedLabelStyle}
      labelProps={labelProps}
      isVisible={isVisible}
      arrowStyle={arrowStyle}
      style={style}
      {...props}
    />
  );

  return isSearchable ? renderSearchInput() : renderSelectText();
}

VFDropdownInput.defaultProps = {
  theme: LightThemeColors,
  isArrowShown: true,
};
VFDropdownInput.propTypes = {
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  getLayout: PropTypes.func,
  toggle: PropTypes.func,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  opacity: PropTypes.number,
  isArrowShown: PropTypes.bool,
  selectedItem: PropTypes.objectOf({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
  labelProps: PropTypes.object,
  isVisible: PropTypes.bool,
  selectedLabelStyle: ViewPropTypes.style,
  labelStyle: ViewPropTypes.style,
  placeholderStyle: ViewPropTypes.style,
  arrowStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  labelFontSize: PropTypes.number,
  searchInputFontSize: PropTypes.number,
};

export default VFDropdownInput;
